import { type FormKitNode } from '@formkit/core'
import { clone } from '@formkit/utils'

export default function createLoadingSpinnerPlugin(node: FormKitNode) {
  if (node.props.family !== 'button') return

  node.addProps(['loading'])

  node.on('created', () => {
    if (node.props.definition) {
      const inputDefinition = clone(node.props.definition)
      const originalSchema = inputDefinition.schema
      const higherOrderSchema = (extensions: any) => {
        extensions.outer = {
          ...extensions.outer,
          attrs: {
            'data-dbc-loading': {
              if: '$loading',
              then: 'true',
            },
          },
        }

        extensions.input = {
          ...extensions.input,
          children: {
            if: '$loading',
            then: {
              $el: 'div',
              attrs: {
                class: 'formkit-loading-pulse',
              },
            },
            else: {
              children: [
                {
                  if: '$_rawPrefixIcon',
                  $el: 'span',
                  attrs: {
                    class: `$classes.prefixIcon + " " + $classes.icon`,
                    innerHTML: '$_rawPrefixIcon',
                  },
                },
                {
                  $el: 'span',
                  children: ["$label || ''"],
                },
                {
                  if: '$_rawSuffixIcon',
                  $el: 'span',
                  attrs: {
                    class: `$classes.suffixIcon + " " + $classes.icon`,
                    innerHTML: '$_rawSuffixIcon',
                  },
                },
              ],
            },
          },
        }

        //@ts-ignore
        return originalSchema(extensions)
      }
      inputDefinition.schema = higherOrderSchema
      node.props.definition = inputDefinition
    }
  })
}
